import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconSleekSilhouetteSectional = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="3.6"
      y="14.6"
      width="3.8"
      height="10.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="25.6"
      y="23.6"
      width="17.8"
      height="8.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="13.6"
      y="18.6"
      width="29.8"
      height="4.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="7.6"
      y="11.6"
      width="5.8"
      height="12.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="3.6"
      y="23.6"
      width="26.8"
      height="11.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
  </svg>;
};

IconSleekSilhouetteSectional.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconSleekSilhouetteSectional;
